import {defaultFilter, formGroup} from "./config";
import * as R from "ramda";

const isFilter = (filter) => {
    return Object.keys(filter).some(
        key => defaultFilter[key] !== filter[key]
    );
};

const constructFilter = (filter) => {
    return {
        ...filter,
        serviceCategory: filter?.serviceCategory?.value,
        kodeVarian: filter?.kodeVarian?.value,
        namaVarian: filter?.namaVarian?.label,
    };
};

const validate = (controls) => {
    let err = {};
    for (const [key, val] of Object.entries(formGroup)) {
        const message = validateEmptyValue(key, val, controls);
        if (message) {
            err[key] = message;
        }
    }
    return err;
};

function validateEmptyValue(key, val, data) {
    if (R.and(val.mandatory, R.or(!data?.[key], R.isEmpty(data?.[key])))) {
        return "Field belum diisi";
    }

    return null;
}

export const service = {
    isFilter,
    constructFilter,
    validate,
};